// @ts-nocheck
import React, { useState, useCallback } from 'react';
import { useLocalization, type Language } from '../../../../../config/localization';
import CurlExamplesContent from '../../../../ui/api/CurlExamplesContent';
import OpenApiSpecModal from '../../../../ui/overlays/modals/OpenApiSpecModal';
import Icon, { ICONS } from '../../../../ui/icons';
import type { BaseSectionProps } from './index';

interface ApiSectionProps extends BaseSectionProps {
  workflowId: number;
}

export default function ApiSection({
  workflow,
  language,
  workflowId
}: ApiSectionProps) {
  const t = useLocalization(language);
  const [showOpenApiModal, setShowOpenApiModal] = useState(false);

  const createAuthHeaders = useCallback(async (): Promise<Record<string, string>> => {
    const token = await window.Clerk?.session?.getToken({ template: 'withmail' });
    if (!token) {
      throw new Error('Not authenticated');
    }
    return {
      Authorization: `Bearer ${token}`
    };
  }, []);

  return (
    <div className="space-y-6">
      {/* Header with OpenAPI button */}
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-medium text-white">
            {t.admin?.api || 'API'}
          </h3>
          <p className="text-sm text-gray-400 mt-1">
            {t.admin?.apiDescription || 'API documentation and cURL examples for this workflow'}
          </p>
        </div>
        <button
          onClick={() => setShowOpenApiModal(true)}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
        >
          <Icon name={ICONS.DOCUMENT} size={18} />
          <span>OpenAPI Spec</span>
        </button>
      </div>

      {/* cURL Examples Content */}
      <CurlExamplesContent
        workflowId={workflowId.toString()}
        language={language}
        t={t}
        createAuthHeaders={createAuthHeaders}
      />

      {/* OpenAPI Spec Modal */}
      {showOpenApiModal && (
        <OpenApiSpecModal
          workflowId={workflowId.toString()}
          onClose={() => setShowOpenApiModal(false)}
          language={language}
          t={t}
        />
      )}
    </div>
  );
}
